module.exports = __webpack_public_path__ + "static/media/sunday.61c26c65.ogg";